// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2816 ? "9c0540d4" : chunkId) + "." + {"540":"5c4a910393acbe12","1432":"2df02ffa5ef648cb","2816":"94affac786a30459","5374":"4b3fdf0c5e1a70a5","8047":"53d26f153f78bd3a","9861":"b0cbf7008d54b52e"}[chunkId] + ".js";
};